import request from './request';

export interface RequestStatusStat {
  status: number;
  label: string;
  count: number;
}

export interface RequestCourseStat {
  courseId: string;
  courseName: string;
  count: number;
}

/**
 * Dashboard stats — distinct applicants (by email) per request status for
 * the given year.
 *
 * @param year
 */
export async function statsByStatus(
  year: number
): Promise<{ year: number; statuses: RequestStatusStat[] }> {
  return request('GET', '/api/stats/by-status', { year });
}

/**
 * Dashboard stats — distinct applicants (by email) per course for the given
 * year, sorted by count descending.
 *
 * @param year
 */
export async function statsByCourse(
  year: number
): Promise<{ year: number; courses: RequestCourseStat[] }> {
  return request('GET', '/api/stats/by-course', { year });
}
